export const COLLAPSIBLE_MONTHS = ['TBC', 'Special Events'];

export const REGULAR_MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function groupSchedule(entries) {
  const byYear = {};
  for (const e of entries) {
    const year = String(e.year);
    if (!byYear[year]) byYear[year] = {};
    if (!byYear[year][e.month]) byYear[year][e.month] = [];
    byYear[year][e.month].push(e);
  }
  return byYear;
}

export function renderGameSlot(game) {
  return (
    <div className={`game-slot${game.streamed ? ' streamed' : ''}`} key={`${game.id}-${game.title}`}>
      <img src={game.poster} alt={game.title} />
      <div className="game-title">{game.title}</div>
    </div>
  );
}

export function renderSetupListItem(item) {
  return (
    <li key={item.label}>
      <strong>{item.label}:</strong> {item.text}
      {item.link && (
        <a href={item.link.href}>
          <span className="highlight">{item.link.label}</span>
        </a>
      )}
      {item.textAfter || ''}
    </li>
  );
}
